import type { JsonMap } from '@st/util/json-value'
import { defSelector } from '@st/redux'
import type { STFolderModuleState } from './st-folder-types'
import { isOptimisticOperationItem } from './operation-request-selectors'

const EMPTY_INPUTS: JsonMap = {}
const EMPTY_REQUESTS: Extract<STFolderModuleState, { status: 'ready' }>['requestQueue']['items'] =
  []
const selFolderInputs = (state: STFolderModuleState) => {
  if (state.status != 'ready') return undefined
  return state.folderState.inputs
}
const selQueuedRequests = (state: STFolderModuleState) => {
  if (state.status != 'ready') return EMPTY_REQUESTS
  return state.requestQueue.items
}

export const selResolvedInputs = defSelector(
  [selFolderInputs, selQueuedRequests],
  (folderInputs, queuedRequests): JsonMap => {
    if (!folderInputs) return EMPTY_INPUTS

    const inputs: JsonMap = { ...folderInputs }

    for (const item of queuedRequests) {
      if (!isOptimisticOperationItem(item)) continue
      const request = item.op.request
      if (request.type == 'folders/setFolderInputs' && request.inputs) {
        Object.assign(inputs, request.inputs)
      }
    }

    return inputs
  }
)
